import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { Router } from '@angular/router';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {
  private count = 0; // Contatore per tracciare il numero di richieste attive
  private loader = document.getElementById('nb-global-spinner'); // Riferimento al loader

  // Lista esclusione spinner
  private listaChiamate: string[] = [
    '/CentroFunzionalePortaleRest/rest/recuperodati/stazioniByFilters?idTipoSensore',
    '/CentroFunzionalePortaleRest/rest/vote/insert',
    '/CentroFunzionalePortaleRest/rest/vote/update',
    '/CentroFunzionalePortaleRest/rest/recuperodati/temporeale/',
    '/CentroFunzionalePortaleRest/rest/recuperodati/sensoriByFilters'
  ];

  constructor(private router: Router) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    
    const isExcluded = this.listaChiamate.some(url => request.url.includes(url));
    
    
    if (!isExcluded) {
      this.showLoader();
      this.count++;
    }

    // Gestione del token JWT (se presente nella sessione)
    const token = sessionStorage.getItem('jwtToken');
    if (token) {
      request = request.clone({
        headers: request.headers.set('Authorization', `Bearer ${token}`)
      });
    }

    // Aggiunge Content-Type solo se mancante
    if (!request.headers.has('Content-Type')) {
      request = request.clone({
        headers: request.headers.set('Content-Type', 'application/json')
      });
    }

    return next.handle(request).pipe(
      tap(
        event => {
          if (event instanceof HttpResponse) {
            // Puoi gestire eventuali logiche di successo qui
          }
        },
        error => {
          this.handleError(error);
        }
      ),
      finalize(() => {
        if (!isExcluded) {
          
          this.count--;
          if (this.count === 0) {
            this.hideLoader();
          }
        }
      })
    );
  }

  private showLoader(): void {
    this.loader = document.getElementById('nb-global-spinner'); // Reinizializza il riferimento
    if (this.loader) {
      this.loader.classList.remove('d-none');
    }
  }
  
  private hideLoader(): void {
    this.loader = document.getElementById('nb-global-spinner'); // Reinizializza il riferimento
    if (this.loader) {
      this.loader.classList.add('d-none');
    }
  }

  private handleError(error: any): void {
    let errorMessage = 'C\'è stato un errore server durante la richiesta effettuata. ' +
      'Si prega di riprovare più tardi e se il problema dovesse persistere contattare l\'amministratore di sistema.';

    if (error.status === 401) {
      errorMessage = "Sessione scaduta. Effettuare nuovamente l'accesso.";
      setTimeout(() => this.logout(), 3000);
    } else if (error.status === 404) {
      errorMessage = "Richiesta non trovata.";
    }

    console.error('Errore HTTP:', errorMessage, error);
    this.hideLoader();
  }

  private logout(): void {
    this.router.navigate(['account/login']);
  }
}
